module.exports = __webpack_public_path__ + "media/stylesheets/images/logo3-49568bb1e13e31ec47b58cce7be05133.jpg";